"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeDirectDebitAmountConfirmUI = void 0;
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../shared/core");
var copy_1 = require("../../../copy");
var utils_1 = require("../../../utils");
var ChangeDirectDebitAmountConfirmUI = function (_a) {
    var amount = _a.amount, upcomingPaymentAmount = _a.upcomingPaymentAmount, upcomingPaymentDate = _a.upcomingPaymentDate, futureUpcomingPaymentDate = _a.futureUpcomingPaymentDate, scheduleDay = _a.scheduleDay;
    var _b = (0, core_1.useCopy)(copy_1.defaultOptions), copy = _b.copy, Copy = _b.Copy;
    var _c = (0, core_1.useComponents)(), Card = _c.Card, Heading1 = _c.Heading1, Stack = _c.Stack;
    var displayUpcomingInfo = upcomingPaymentAmount && upcomingPaymentDate && futureUpcomingPaymentDate;
    return (react_1.default.createElement(Card, { "data-testid": "dd-changed-confirmation" },
        react_1.default.createElement(Stack, { spaceBetween: [4, 6] },
            react_1.default.createElement("div", null,
                react_1.default.createElement(Heading1, null,
                    react_1.default.createElement(Copy, { copyKey: "changeDirectDebitConfirmHeading" })),
                react_1.default.createElement(Copy, { copyKey: "changeDirectDebitConfirmChanged", values: {
                        formattedAmount: (0, core_1.major0DP)((0, core_1.majorToMinor)(amount)),
                    } }),
                scheduleDay ? (react_1.default.createElement(Copy, { copyKey: "changeDirectDebitConfirmScheduleDay", values: { nextScheduledDay: (0, utils_1.nextScheduleDay)(scheduleDay) } })) : null,
                displayUpcomingInfo ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Copy, { copyKey: "changeDirectDebitConfirmPaymentInfo", values: {
                            nextFormattedAmount: (0, core_1.major2DP)((0, core_1.majorToMinor)(upcomingPaymentAmount)),
                            nextFormattedDate: (0, date_fns_1.format)(upcomingPaymentDate, 'd MMM'),
                        } }),
                    react_1.default.createElement(Copy, { copyKey: "changeDirectDebitConfirmNewAmount", values: {
                            futureFormattedAmount: (0, core_1.major2DP)((0, core_1.majorToMinor)(amount)),
                            futureFormattedDate: (0, date_fns_1.format)(futureUpcomingPaymentDate, 'd MMM'),
                        } }))) : null,
                react_1.default.createElement(Copy, { copyKey: "goToHomeLink" })),
            react_1.default.createElement(core_1.FeedbackPrompt, { id: "directDebitAmount", probability: 50, label: copy('changeDirectDebitAmountFeedbackPrompt') }))));
};
exports.ChangeDirectDebitAmountConfirmUI = ChangeDirectDebitAmountConfirmUI;
